if (!customElements.get("download-page-with-navigation")) {
  class DownloadPageWithNavigation extends HTMLElement {
    linkClicked = false;

    connectedCallback() {
      const self = this;
      this.addEventListener('click', function (evt) {
        if (evt.target.closest('a')) {
          const anchor = evt.target.closest('a');
          if (anchor.closest('.card-item')?.querySelector('[title="Cura"]')) {
            window.clarity?.("event", "DownloadCura")
          }
          if (anchor.closest('.card-item')?.querySelector('[title="ElegooSlicer"]')) {
            window.clarity?.("event", "DownloadElegooSlicer")
          }
        }
      })
      this.buttons = Array.from(
        this.querySelectorAll("button.download-page-with-navigation--button")
      );
      this.pages = Array.from(
        this.querySelectorAll(".download-page-with-navigation--page")
      );
      this.series = Array.from(
        this.querySelectorAll(
          ".download-page-with-navigation--page .series-select select"
        )
      );
      this.models = Array.from(
        this.querySelectorAll(
          ".download-page-with-navigation--page .model-select select"
        )
      );

      this.buttons.forEach((button, i) => {
        button.addEventListener("click", () => {
          self.linkClicked = true;
          this.buttonClick(button, i);
        });
      });
      const selectButtons = this.querySelector(
        ".download-page-with-navigation--select"
      );

      this.initSelect();

      if (selectButtons) {
        selectButtons.addEventListener("change", (e) => {
          self.linkClicked = true;

          // Get the button same as the value of the select
          const button =
            this.querySelector(
              `button.download-page-with-navigation--button[data-handle="${e.target.value}"]`
            ) ||
            this.querySelector(
              `button.download-page-with-navigation--button[data-value="${e.target.value}"]`
            );

          // Get index of the button
          const index = this.buttons.indexOf(button);

          if (index > -1) {
            // Click the button
            this.buttonClick(button, index);
          }
        });
        const searchParams = new URL(window.location.href).searchParams;
        if (searchParams.get("c1")) {
          selectButtons.value = searchParams.get("c1");
          selectButtons.dispatchEvent(new Event("change"));
        }
      }
    }
    buttonClick(button, i) {
      const self = this;

      [].forEach.call(this.buttons, function (el) {
        el.classList.remove("active");
      });
      button.classList.add("active");

      [].forEach.call(this.pages, function (el) {
        el.classList.remove("active");
      });
      this.pages[i].classList.add("active");
      this.pages[i]
        .querySelector(".model-select select")
        .dispatchEvent(new Event("change"));
    }
    initSelect() {
      this.series.forEach((serie, i) => {
        serie.addEventListener("change", (e) => {
          const productIndex = serie.options[serie.options.selectedIndex].value;
          var models = serie
            .closest(".download-page-with-navigation--page")
            .querySelectorAll(".model-select");
          models.forEach((el) => {
            el.classList.remove("active");
          });
          models[productIndex].classList.add("active");
          models[productIndex]
            .querySelector("select")
            .dispatchEvent(new Event("change"));
        });
      });

      this.models.forEach((model, i) => {
        model.addEventListener("change", (e) => {
          const page = model.closest(".download-page-with-navigation--page");
          const handle = model.options[model.options.selectedIndex].value;
          const featuredImage =
            model.options[model.options.selectedIndex].dataset["featuredImage"];
          const name = model.options[model.options.selectedIndex].text;
          page.querySelector(".download-navigation-product img").src =
            featuredImage;
          page.querySelector(
            ".download-navigation-product .product-name"
          ).innerText = name;
          this.updateCards.call(page, handle);
          const series = page.querySelector(".series-select select");
          if (series) {
            const seriesName = Array.from(series.children)
              .find((op) => op.value === series.value)
              ?.innerText.trim();

            let tipsHTML = "";

            try {
              // for series
              const settings = JSON.parse(
                this.querySelector(
                  'script[type="application/json"]#download-center-settings'
                ).textContent
              );
              const currentSerieSettings = settings
                .find((setting) =>
                  setting.series.find((serie) => serie.name === seriesName)
                )
                .series.find((serie) => serie.name === seriesName);
              tipsHTML =
                currentSerieSettings?.tips?.replace(/\n/g, "<br>") || "";

              if (currentSerieSettings) {
                const productHandle = Array.from(model.children).find(
                  (op) => op.value === model.value
                )?.dataset["handle"];
                if (productHandle) {
                  tipsHTML =
                    currentSerieSettings.products
                      .find((p) => p.handle === productHandle)
                      ?.tips?.replace(/\n/g, "<br>") || tipsHTML;
                }
              }
            } catch {}

            const tips = page.querySelector(".download-navigation-tips .rte");
            if (!tips.dataset["tips"]) {
              tips.dataset["tips"] = tips.innerHTML;
            }

            tips.innerHTML = tipsHTML || tips.dataset["tips"] || tips.innerHTML;
            tips.style.display = 'block';
          }
        });

        if (model.parentNode.classList.contains("active")) {
          model.dispatchEvent(new Event("change"));
        }
      });
    }
    updateCards(handle) {
      this.querySelectorAll(".card-item").forEach((card) => {
        card.classList.add("hidden");
        card.querySelector(".item-content").innerHTML = "";
      });
      this.querySelectorAll(".card-item p").forEach((pel) => {
        pel.remove();
      });
      let linksStr = this.querySelector("#links-" + handle).textContent.trim();
      if (linksStr) {
        let linksArr = JSON.parse(linksStr);
        linksArr.forEach((linkStr) => {
          // non-beaking space
          const arr = linkStr.replace(/\s/g, ' ').split(" -- ");
          if (arr.length > 2) {
            const card = this.querySelector("[data-card='" + arr[0] + "']");
            if (card) {
              let itemLinks = this.querySelector(
                "[data-card-sub='" + arr[0] + "-" + arr[1] + "']"
              );
              if (!itemLinks) {
                if (arr[1]) {
                  card
                    .querySelector(".item-content")
                    .insertAdjacentHTML(
                      "beforeend",
                      '<div class="item-links" data-card-sub="' +
                        arr[0] +
                        "-" +
                        arr[1] +
                        '"><div class="title">' +
                        arr[1] +
                        "</div><ul></ul></div>"
                    );
                } else {
                  card
                    .querySelector(".item-content")
                    .insertAdjacentHTML(
                      "beforeend",
                      '<div class="item-links" data-card-sub="' +
                        arr[0] +
                        "-" +
                        arr[1] +
                        '"><ul></ul></div>'
                    );
                }
              }
              itemLinks = this.querySelector(
                "[data-card-sub='" + arr[0] + "-" + arr[1] + "']"
              );
              const itemUl = itemLinks.querySelector("ul");
              let liHtml =
                '<li><span class="link">' +
                arr[2] +
                '<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L1 9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>';
              if (arr[3]) {
                liHtml +=
                  '<span class="update-log"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.50033 10.0834C2.96895 10.0834 0.916992 8.03146 0.916992 5.50008C0.916992 2.96871 2.96895 0.916748 5.50033 0.916748C8.0317 0.916748 10.0837 2.96871 10.0837 5.50008C10.0837 8.03146 8.0317 10.0834 5.50033 10.0834ZM5.50033 9.16675C6.47279 9.16675 7.40542 8.78044 8.09305 8.09281C8.78068 7.40517 9.16699 6.47254 9.16699 5.50008C9.16699 4.52762 8.78068 3.59499 8.09305 2.90736C7.40542 2.21972 6.47279 1.83341 5.50033 1.83341C4.52786 1.83341 3.59523 2.21972 2.9076 2.90736C2.21997 3.59499 1.83366 4.52762 1.83366 5.50008C1.83366 6.47254 2.21997 7.40517 2.9076 8.09281C3.59523 8.78044 4.52786 9.16675 5.50033 9.16675ZM5.04199 7.33341H5.95866V8.25008H5.04199V7.33341ZM5.04199 6.42041C5.04199 6.42041 5.95866 6.41675 5.95866 6.42041C5.95866 5.96116 7.33366 5.50008 7.33366 4.58341C7.33366 3.5705 6.52103 2.75008 5.50445 2.75008C5.26335 2.74954 5.0245 2.79656 4.8016 2.88845C4.57869 2.98034 4.3761 3.1153 4.20542 3.28559C4.03474 3.45589 3.89933 3.65817 3.80694 3.88087C3.71455 4.10357 3.66699 4.34231 3.66699 4.58341H4.58366C4.58366 4.07925 4.99616 3.66675 5.50033 3.66675C6.00449 3.66675 6.41699 4.07925 6.41699 4.58341C6.41699 4.99591 5.04199 5.66829 5.04199 6.42041Z" fill="#DEDEDE"></path></svg><div class="pop">' +
                  arr[3] +
                  "</div></span>";
              }
              liHtml += "</li>";
              itemUl.insertAdjacentHTML("beforeend", liHtml);
              card.querySelectorAll(".item-links").length > 1
                ? card.classList.add("two-column")
                : "";
              card.classList.remove("hidden");
            }
          }
        });
      }

      // document
      //   .querySelectorAll(".download-navigation-cards a")
      //   .forEach((aTag) => {
      //     aTag.addEventListener("click", (e) => {
      //       e.preventDefault();
      //       // replace with cdn domain.
      //       const link = aTag.href.replace('elegoo-downloads.oss-us-west-1.aliyuncs.com', 'download-cdn.elegoo.com');
      //       window.open(link);
      //     });
      //   });

      let remarkStr = this.querySelector(
        "#remark-" + handle
      ).textContent.trim();
      if (remarkStr) {
        let remarkArr = JSON.parse(remarkStr);
        remarkArr.forEach((remark) => {
          const arr = remark.split(" -- ");
          if (arr[0] && !arr[1]) {
            const cardRemark = this.querySelector(
              "[data-card='" + arr[0] + "']"
            );
            cardRemark && arr[2]
              ? cardRemark.insertAdjacentHTML(
                  "beforeend",
                  "<p class='item-remark'>" + arr[2] + "</p>"
                )
              : "";
          } else {
            const itemLinkP = this.querySelector(
              "[data-card-sub='" + arr[0] + "-" + arr[1] + "']"
            );
            if (itemLinkP && arr[2]) {
              itemLinkP.insertAdjacentHTML(
                "beforeend",
                "<p>" + arr[2] + "</p>"
              );
            }
          }
        });
      }
    }
  }
  customElements.define(
    "download-page-with-navigation",
    DownloadPageWithNavigation
  );
}
